const ResultPanelPreCartSearch = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
      <div>Complete a selection to see delivery option information.</div>
    </div>
  );
};

export default ResultPanelPreCartSearch;
